import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Login({ onLogin }) {
  const [recoveryCode, setRecoveryCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!recoveryCode.trim()) {
      setError('Recovery code is required');
      return;
    }

    try {
      setError('');
      setLoading(true);

      const response = await fetch('/api/employees/recover', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ recoveryCode: recoveryCode.trim() }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to login');
      }

      // Store employee data in localStorage
      localStorage.setItem('employeeId', data.id);
      localStorage.setItem('employee', JSON.stringify(data));

      onLogin(data);
    } catch (error) {
      console.error('Login error:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-base-200 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="card w-full max-w-md mx-auto bg-base-100 shadow-xl">
        <div className="card-body">
          <h2 className="card-title text-3xl font-bold text-center justify-center">
            Sign in to your account
          </h2>

          <form className="space-y-6 mt-6" onSubmit={handleSubmit}>
            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Recovery Code</span>
              </label>
              <input
                type="text"
                id="recovery-code"
                name="recovery-code"
                required
                value={recoveryCode}
                onChange={(e) => setRecoveryCode(e.target.value)}
                placeholder="Enter your recovery code"
                className="input input-bordered w-full"
              />
            </div>

            {error && (
              <div className="alert alert-error">
                <span>{error}</span>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className={`btn btn-primary w-full ${loading ? 'loading' : ''}`}
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </form>

          <div className="divider">OR</div>

          <div className="text-center text-sm">
            <span className="text-base-content/70">
              Don't have an account?{' '}
              <Link to="/register" className="link link-primary">
                Register
              </Link>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
} 